import { UserContext } from 'context/userContext';
import { useContext } from 'react';

export const useMe = () => {
    const { data, ...other } = useContext(UserContext);
    return { whoami: data, ...other };
};
